function banner_slider() {
$('.banner-list').slick({
    arrows: false,
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 300,
    slidesToShow: 1,
    adaptiveHeight: true
  });
}
banner_slider();
document.addEventListener("shopify:section:load", banner_slider);



// count show 

$(document).ready(function(){
    // Get the content of the <span class="count">
    var countContent = $('div#pagination .count').html();
    $('.collection_showing_counts').html(countContent);
});

//review slider
function review_slider() {
$('.review-slider').slick({
    arrows: false,
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
  slidesToScroll:2,
  appendDots: $('.review-dots'),
  responsive: [{
    breakpoint: 1380,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
        }
    },{
        breakpoint: 1199,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          
    }
    }, {
        breakpoint: 767,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          
    }
    },
      {
        breakpoint: 640,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          
    }
    }
  ]
   
  });
}
review_slider();
document.addEventListener("shopify:section:load", review_slider);



function usp_lists() {
$('.usp-lists-mobile').slick({
    arrows: false,
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 300,
    slidesToShow: 4,
  slidesToScroll:4,  
  responsive: [{
    breakpoint: 1380,
        settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
        }
    },
      {
        breakpoint: 550,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          
    }
    }
  ]
   
  });
}
usp_lists();
document.addEventListener("shopify:section:load", usp_lists);

function icons_list() {
$('.icons_list-mobile').slick({
    arrows: false,
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 300,
    slidesToShow: 4,
  slidesToScroll:4,  
  responsive: [{
    breakpoint: 1380,
        settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
        }
    },
      {
        breakpoint: 550,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          
    }
    }
  ]
   
  });
}
icons_list();
document.addEventListener("shopify:section:load", icons_list);
